export enum NotesRecipient {
  DOCTOR = "DOCTOR",
  TECHNICIAN = "TECHNICIAN",
}
